import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import seatedWoman from 'assets/images/sit-woman-shape.webp';

const FeedbackHeader = ({ changeHomeStatus }) => {
  const { t } = useTranslation();

  return (
    <header className="feedback-view__header">
      <img src={seatedWoman} alt="Shape of a seated woman" className="feedback-view__header_img" />
      <button type="button" className="feedback-view__header_btn" onClick={changeHomeStatus}>
        {t('evieApp.feedback.skipBtn')}
      </button>
      <h2 className="feedback-view__header_title">{t('evieApp.feedback.title')}</h2>
      <p className="feedback-view__header_content">{t('evieApp.feedback.content')}</p>
    </header>
  );
};

FeedbackHeader.propTypes = {
  changeHomeStatus: PropTypes.func.isRequired,
};

export default FeedbackHeader;
